module.exports = __webpack_public_path__ + "static/media/mozart.0595fbda.jpg";